var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { HecClient } from './hec-client';
import { LogLevel } from './types';
export class SplunkLogger {
    constructor(config) {
        var _a, _b, _c, _d, _e;
        if (!config.endpoint) {
            throw new Error('SplunkConfig is missing required field: endpoint');
        }
        if (!config.token) {
            throw new Error('SplunkConfig is missing required field: token');
        }
        this.source = config.source;
        this.sourcetype = config.sourcetype;
        this.index = config.index;
        this.minLogLevel = (_a = config.minLogLevel) !== null && _a !== void 0 ? _a : LogLevel.INFO;
        this.defaultMetadata = (_b = config.defaultMetadata) !== null && _b !== void 0 ? _b : {};
        this.hecClient = new HecClient(Object.assign(Object.assign({}, config), { batchSize: (_c = config.batchSize) !== null && _c !== void 0 ? _c : 10, flushIntervalMs: (_d = config.flushIntervalMs) !== null && _d !== void 0 ? _d : 5000, maxRetries: (_e = config.maxRetries) !== null && _e !== void 0 ? _e : 3 }));
        // Log initialization event (Requirement 1.4)
        this.info('Splunk logger initialized', {
            source: config.source,
            sourcetype: config.sourcetype,
        });
    }
    /** Expose hecClient for testing. */
    get _hecClient() {
        return this.hecClient;
    }
    debug(message, metadata) {
        this.log(LogLevel.DEBUG, message, metadata);
    }
    info(message, metadata) {
        this.log(LogLevel.INFO, message, metadata);
    }
    warn(message, metadata) {
        this.log(LogLevel.WARN, message, metadata);
    }
    error(message, metadata) {
        this.log(LogLevel.ERROR, message, metadata);
    }
    flush() {
        return __awaiter(this, void 0, void 0, function* () {
            return this.hecClient.flush();
        });
    }
    /** Update default metadata that gets merged into every log event. */
    setDefaultMetadata(metadata) {
        this.defaultMetadata = Object.assign(Object.assign({}, this.defaultMetadata), metadata);
    }
    destroy() {
        this.hecClient.destroy();
    }
    log(level, message, metadata) {
        if (level < this.minLogLevel)
            return;
        const event = {
            time: Date.now() / 1000,
            source: this.source,
            sourcetype: this.sourcetype,
            index: this.index,
            event: {
                message,
                severity: LogLevel[level],
                metadata: Object.assign(Object.assign({}, this.defaultMetadata), metadata),
            },
        };
        this.hecClient.enqueue(event);
    }
}
